var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-uppercase font-weight-medium text-button",attrs:{"color":"primary","block":"","large":"","solo":""},on:{"click":_vm.startAuthFlow}},[_vm._v("\n  "+_vm._s(_vm.config.buttonText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }